module.exports = __webpack_public_path__ + "media/images/photography/company-photo-f6cfde2f001cfd85d45755493e9c2398.jpg";